import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

export const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    meta: {
      title: "【专题】聚焦2021年綦江两会"
    },
    component: () => import("@/views/Home.vue")
  },
  {
    path: "/video-list",
    name: "VideoList",
    meta: {
      title: "【专题】聚焦2021年綦江两会"
    },
    component: () => import("@/views/VideoList.vue")
  },
  {
    path: "/news-list",
    name: "NewsList",
    meta: {
      title: "【专题】聚焦2021年綦江两会"
    },
    component: () => import("@/views/NewsList.vue")
  },
  //2023专题
  {
    path: "/2023",
    name: "Home2023",
    meta: {
      title: "【专题】聚焦2023年綦江两会"
    },
    component: () => import("@/views/2023/Home.vue")
  },
  {
    path: "/2023/video-list",
    name: "VideoList2023",
    meta: {
      title: "【专题】聚焦2023年綦江两会"
    },
    component: () => import("@/views/2023/VideoList.vue")
  },
  {
    path: "/2023/news-list",
    name: "NewsList2023",
    meta: {
      title: "【专题】聚焦2023年綦江两会"
    },
    component: () => import("@/views/2023/NewsList.vue")
  },
  //2024两会专题
  {
    path: "/2024",
    name: "Home2024",
    meta: {
      title: "【专题】聚焦2024年綦江两会"
    },
    component: () => import("@/views/2024/Home.vue")
  },
  {
    path: "/2024/video-list",
    name: "VideoList2024",
    meta: {
      title: "【专题】聚焦2024年綦江两会"
    },
    component: () => import("@/views/2024/VideoList.vue")
  },
  {
    path: "/2024/news-list",
    name: "NewsList2024",
    meta: {
      title: "【专题】聚焦2024年綦江两会"
    },
    component: () => import("@/views/2024/NewsList.vue")
  }
];
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
